export default {
  menuList: state => state.router.menuList,
  tabList: state => state.router.tabList,
  breadCrumbList: state => state.router.breadCrumbList,
  userInfo: state => state.router.userInfo,
  userType: state => state.router.userType,
  businessAccount: state => state.router.businessAccount,
  perTree: state => state.router.perTree
  // user: state => state.router.user
}
